import React from "react";
import { IonTitle } from "@ionic/react";
import closeIcon from "../../../../assets/imgs/close.svg";
import chatAiLoading from "../../../../assets/imgs/chat_ai_loading.svg";
import { FadeText } from "../../../../Components/ui/fade-text";
import { SelectLeagueButton } from "../../../../Components/LeagueSync/SelectLeagueButton/SelectLeagueButton";

interface ChatbotHeaderProps {
  dismiss: () => void;
  showTitle?: boolean;
  title?: string;
  showLeagueSkeleton?: boolean;
}

const ChatbotHeader: React.FC<ChatbotHeaderProps> = ({
  dismiss,
  showTitle = false,
  title = "RotoBot AI",
  showLeagueSkeleton = false,
}) => {
  return (
    <div className="p-2 flex justify-between items-center sticky top-0 z-50">
      <div
        onClick={dismiss}
        className="flex items-center justify-center w-[32px] h-[32px] rounded-full cursor-pointer"
      >
        <img src={closeIcon} alt="close" className="w-[12.4px] h-[12.4px]" />
      </div>

      <IonTitle>
        {showTitle ? (
          <div className="flex flex-row items-center justify-center gap-2">
            <img
              src={chatAiLoading}
              alt="chatAiLoading"
              className="w-[24.2px] h-[19.4px]"
            />

            <FadeText
              className="text-[16px] font-medium text-white"
              direction="up"
              framerProps={{
                show: { transition: { delay: 0.2 } },
              }}
              text={title}
            />
          </div>
        ) : (
          showLeagueSkeleton ? (
            <div className="flex items-center justify-center">
              <SelectLeagueButton />
            </div>
          ) : null
        )}
      </IonTitle>
    </div>
  );
};

export default ChatbotHeader;
